export class ReasonCodeLoad {
  public static readonly type = '[ReasonCode] Load';
}

export class ReasonCodeInitialState {
  public static readonly type = '[ReasonCode] Set Initial State';
}
